(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("size-chart-modal");

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".size-chart-trigger");
    if (trigger && modal) {
      modal.style.display = "flex";
    }

    if (e.target.closest(".size-chart-close") || e.target === modal) {
      if (modal) modal.style.display = "none";
    }
  });

  document.addEventListener("keydown", function(e){
    if (e.key === "Escape" && modal && modal.style.display === "flex") {
      modal.style.display = "none";
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
